// Wejście do panelu. Panel v2 jest JEDYNYM panelem.
//
// Rozgałęzienie po `profil.typ` (flota → stare drzewo, jdg|spolka → v2)
// istniało wyłącznie po to, żeby nie wywrócić ekranu żywym klientom floty.
// Takich nie ma ani jednego — jest tylko konto testowe właściciela (decyzja
// z 13.08.2026 — utrzymywanie dwóch drzew kosztowałoby podwójną pracę bez
// jednego beneficjenta.
//
// Stare ekrany nie zniknęły: kierowcy, rozliczenia, flota i zgłoszenia jadą
// w nowym szkielecie (PanelV2App), dopóki nie dostaną własnych rozdziałów.
//
// Korytarz /start (osobny kreator poza layoutem panelu, żeby świeża firma
// mogła się skonfigurować przed pulpitem i przed płatnością) zniknął razem
// z ankietą firmy — pytania żyją teraz jako karty zadań na Pulpicie
// (panelv2/pulpit/ZadaniaProfilu.jsx), wewnątrz PanelV2App.

import { lazy, Suspense } from 'react';
import Loader from '@components/Loader';

const PanelV2App = lazy(() => import('./PanelV2App'));

const BramaPanelu = () => (
    <Suspense fallback={<Loader visible pelnyEkran/>}>
        <PanelV2App/>
    </Suspense>
);

export default BramaPanelu;
